<template>
  <div class="main-links">
    <div class="main-links__wrapper">
      <nuxt-link :to="localePath('/profile')" class="btn item">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-user"></use>
        </svg>
        {{ t("account") }}
      </nuxt-link>
      <nuxt-link :to="localePath('/profile/billing')" class="btn item">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-card"></use>
        </svg>
        {{ t("plan_and_billing") }}
      </nuxt-link>
      <nuxt-link :to="localePath('/profile/statistics')" class="btn item">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-chart"></use>
        </svg>
        {{ t("statistics") }}
      </nuxt-link>
      <nuxt-link :to="localePath('/profile/services')" class="btn item">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-user"></use>
        </svg>
        {{ t("services") }}
      </nuxt-link>
    </div>

    <div v-if="user?.is_admin" class="main-links__wrapper">
      <p class="main-links__title">For Admins</p>

      <nuxt-link :to="localePath('/blog/moderation')" class="btn item">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-blog"></use>
        </svg>
        Blog panel
      </nuxt-link>
      <nuxt-link :to="localePath('/admin/dynamic')" class="btn item">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-puzzle"></use>
        </svg>
        Dynamic pages
      </nuxt-link>
      <nuxt-link :to="localePath('/admin/markets')" class="btn item">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-archive"></use>
        </svg>
        Market pages
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useStore } from "~/store";
import { useI18n } from "vue-i18n";

const { user } = useStore();
const localePath = useLocalePath();
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.main-links {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    margin: 0;
  }

  &__title {
    padding: 0.8rem 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--accent-on-surface);
    text-transform: uppercase;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    padding: 0.8rem;
    border-radius: 12px;
    font-weight: 600;
    color: var(--surfaces-on-surface);

    &:hover {
      color: var(--accent-on-surface) !important;
      background: var(--surfaces-variable-container);
      svg {
        color: var(--accent-on-surface);
      }
    }
    &.router-link-exact-active {
      color: var(--accent-on-surface) !important;
      background: var(--surfaces-variable-container);
      svg {
        color: var(--accent-on-surface);
      }
    }
    svg {
      width: 20px;
      height: 20px;
      color: var(--surfaces-on-surface-variable);
    }

    &.btn-logout {
      color: var(--destructive);

      svg {
        color: var(--destructive);
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
